function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33317 1.33332H3.99984C3.64622 1.33332 3.30708 1.47379 3.05703 1.72384C2.80698 1.97389 2.6665 2.31303 2.6665 2.66665V13.3333C2.6665 13.6869 2.80698 14.0261 3.05703 14.2761C3.30708 14.5262 3.64622 14.6666 3.99984 14.6666H11.9998C12.3535 14.6666 12.6926 14.5262 12.9426 14.2761C13.1927 14.0261 13.3332 13.6869 13.3332 13.3333V5.33332M9.33317 1.33332C9.54421 1.33297 9.75323 1.37438 9.94819 1.45516C10.1432 1.53594 10.3202 1.65449 10.4692 1.80398L12.8612 4.19598C13.0111 4.34499 13.13 4.52221 13.211 4.71742C13.292 4.91263 13.3335 5.12196 13.3332 5.33332M9.33317 1.33332L9.33317 4.66665C9.33317 4.84346 9.40341 5.01303 9.52843 5.13805C9.65346 5.26308 9.82303 5.33331 9.99984 5.33331L13.3332 5.33332",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.92e39ef2.svg";
export { ForwardRef as ReactComponent };